import * as React from "react";
import { BaseBlock, BaseBlockOptions, broadcastBlockLoad, BFFGateway } from "sb-resp-lib";

import { BaseDict } from "./dict";
import { cmsConfig } from "./config";
import { LeagueListPresenter } from "./ui/LeagueListPresenter";
import { LeagueListPresenterState } from "./state";

/*
    This structure allows us to use mocks during dev
    but not to include them when we do build:release
*/
// import * as MOCKSTYPE from "sb-resp-lib/lib/mocks";
import * as LOCALMOCKTYPES from "../../mocks";
import { Parser } from "../../Parser";
import { Retriever } from "../../Retriever";
// let _: typeof MOCKSTYPE;
let _localMock: typeof LOCALMOCKTYPES;
let _libMocks;
let BFFGateWayMock;
let DataProviderMock;
let deviceChangeDispatcherMock;
if (process.env.NODE_ENV === "development") {
    _localMock = require("../../mocks");
    _libMocks = require("sb-resp-lib/lib/mocks");
    BFFGateWayMock = _localMock.BffGatewayMock;
    DataProviderMock = _localMock.DataProviderMock;
    deviceChangeDispatcherMock = _libMocks.DeviceChangeDispatcherMock.getInstance();
}

export class LeagueListPresenterRoot extends BaseBlock {
    dataProvider!: LeagueListPresenterState;
    options!: BaseBlockOptions;

    // constructor sets defaults
    constructor(
        domId: string,
        options: BaseBlockOptions = {
            dict: BaseDict,
            cms: {},
            navHandler: {},
            dataProvider: {},
            betSlipUtil: {},
            oddsUtil: {},
            facade: {},
            gameStatus: {},
            timeControl: {},
            panelId: "",
            storageUtils: {},
            userInfo: {}
        }
    ) {
        super(domId, options);

        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = { ...BaseDict, ...(options.dict || {}) };

        // merge default and CMS options
        this.options.cms = { ...cmsConfig, ...(options.cms || {}) };

        if (process.env.NODE_ENV === "development") {
            this.options.navHandler.Navigation = {
                adjustPath: (url: string) => `en/sports/${url}`,
                getLiveEventLink: (id: string) => `en/live-betting/#${id}`,
                getLiveBettingLink: () => "en/live-betting"
            }
            this.options.navHandler.OpenLeague = () => { }
            this.options.navHandler.OpenCoupon = () => { }
            // setup data mocks for debug build
            this.dataProvider = new LeagueListPresenterState(
                new Parser(
                    new Retriever(
                        new BFFGateWayMock(),
                        DataProviderMock,
                        deviceChangeDispatcherMock
                    ),
                    cmsConfig,
                    this.options.navHandler
                ),
                this.options
            );

            //export data store to window for debug purposes
            window["LeagueListPresenterState"] = this.dataProvider;
        }

        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {

            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new LeagueListPresenterState(new Parser(new Retriever(new BFFGateway(), options.dataProvider), this.options.cms, this.options.navHandler), this.options);
        }

    }

    beforeActivate() {
        this.dataProvider.activate();
        return this;
    }

    activate() {
        return super.activate(
            <LeagueListPresenter dataProvider={this.dataProvider} dict={this.options.dict} />
        );
    }
}

window["LeagueListPresenter"] = LeagueListPresenterRoot;
broadcastBlockLoad("LeagueListPresenter");
